import { render, staticRenderFns } from "./owner-debtors.vue?vue&type=template&id=d9f73faa"
import script from "./owner-debtors.vue?vue&type=script&lang=js"
export * from "./owner-debtors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports